import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Button from 'react-bootstrap/Button';

import { Helmet } from 'react-helmet';

import CentralLink from '../components/CentralLink.js';

function View404() {

	return (
    <div>
      <Helmet>
        <title>FloodMapper - Page not Found</title>
      </Helmet>
      <Row>
      	<Col xs={12} className="bg-dark text-white"><h4>404 - Page Not Found</h4></Col>
      </Row>
      <br/><br/><br/><p>Sorry, we couldn't find what you were looking for.</p>
      <p><CentralLink to={"/"}><Button variant="dark">Go Home</Button></CentralLink></p>
    </div>
  );
}

export default View404;